import React, { useCallback, useEffect, useState, useRef, useLayoutEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";

import "./../login.scss";
import {
  loginGet,
  loginPost,
  agmsClientLoginPost,
  agmsClientRequestGet,
  requestGet,
  requestPut,
  agmsClientConfirmGet,
  agmsClientRequestPost
} from "../../../apis/request";//"../../apis/request";

import { useRecoilValue, useSetRecoilState, useRecoilState} from "recoil";
import { termAllAgree, annotationChartYAxisAtom, useRefStateAtom } from "../../../states/recoilState"//"../../states/recoilState";

import TextField from '@mui/material/TextField';

import Checkbox from '@mui/material/Checkbox';


import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";

const SignUpComponent = ({logInUp, setLogInUp, termAgreement, setTermAgreement}) => {
    const { t:translate, i18n } = useTranslation();
    
    const [email, setEmail] = useState("");
    const history = useHistory();
    //const [logInUp, setLogInUp] = useState(false);
    
    //const [termAgreement, setTermAgreement] = useState(false);
    const [userCall, setUserCall] = useState("");
    
    const termAllAgreeInfo = useRecoilValue(termAllAgree);
    const setTermAllAgreeInfo = useSetRecoilState(termAllAgree);
    const [isPasswordSignUp, setIsPasswordSignUp] = useState(false);
    
    //이름
    const [name, setName] = useState("");
    
    //키
    const [height, setHeight] = useState('');
    
    //몸무게
    const [weight, setWeight] = useState('');
    
    //나이
    const [age, setAge] = React.useState('');
    const handleChangeAge = (event) => {
        setAge(event.target.value);
    };
    
    //성별
    const [gender, setGender] = React.useState(1603);
    
    //당뇨종류
    const [diabetesType, setDiabetesType] = useState(1706);

    //비밀번호
    const [password, setPassword] = useState("");

    //비밀번호 확인
    const [passwordCheck, setPasswordCheck] = useState("");

    const handleUserPhonePress = (e) => {
        const regex = /^[0-9\b -]{0,13}$/;
        if (regex.test(e.target.value)) {
        setUserCall(e.target.value);
        }
    };

    const onClickGoToLogin = () => {
        //로그인하기로 갈 때는 oauthData를 null로 만들어서 회원가입을 클릭할 때 OAuth로 가지 않게 하자.
        secureLocalStorage.setItem('oauthData', null);
        setLogInUp(false);
    }

    const onChangePasswordSignUp = (e) => {
        const passwordSignUpRegex =
            /^(?=.*[a-zA-Z])(?=.*[!@%$%^&*()+=._-])(?=.*[0-9]).{8,35}$/;
        const passwordSignUpCurrent = e.target.value;
        setPassword(passwordSignUpCurrent);
        if (!passwordSignUpRegex.test(passwordSignUpCurrent)) {
            setIsPasswordSignUp(false);
        } else {
            setIsPasswordSignUp(true);
        }
        if (passwordSignUpCurrent.length === 0) {
            setIsPasswordSignUp(false);
        }
    };

    // #region 이메일 인증 관련
    const [emailCodeId, setEmailCodeId] = useState(null);
    const [certNumber, setCertNumber] = useState('');
    const [certNumberSendCheck, setCertNumberSendCheck] = useState(false);
    const [certNumberCertifiedCheck, setCertNumberCertifiedCheck]= useState(false);
    
    const onSendEmailCode = async (e) => {
        try{
            if(email === null || email.trim() === ""){
                alert(translate('enter_email'));
                return;
            }
            startTimer();
            setCertNumberSendCheck(true);
        
            let result = await agmsClientRequestGet(
                `/api/email/join?email=${email}`
            );
            alert(translate('email_sent'));
            setEmailCodeId(result.email_code_id);
        }
        catch(error){
            if(error.response?.status === 415){
                alert(translate('unable_to_register'));   
                return
            }
        }

        
    };

    const onCheckCertNumber = async (e) => {
        let body = {
            email_code_id : emailCodeId,
            email_code : certNumber
        }
        
        let result = await agmsClientRequestPost(
            `/api/email/code/check`,
            body
        );

        let resultObject = {
            is_success: result.is_success,
            message: result.message
        }

        if(resultObject.is_success){
            setCertNumberCertifiedCheck(true);
            //alert('인증되었습니다.');
            resetTimer();
        } 
        else{
            alert(translate('code_mismatch'));
        }
    };
    // #endregion
    
    // #region 인증번호 타이머 관련
    const INITIAL_SECONDS = 5 * 60;
    const timerRef = useRef(null);
    const [isRunning, setIsRunning] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(INITIAL_SECONDS); // 5분 = 300초

    const formatTime = (totalSeconds) => {
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };
    
    useEffect(() => {
        if(isRunning){
            timerRef.current = setInterval(() => {
            setSecondsLeft(prev => {
                if(prev <= 1){
                clearInterval(timerRef.current);
                setIsRunning(false);
                return 0;
                }
                return prev - 1;
            });
            }, 1000);
            return () => clearInterval(timerRef.current); // 클린업
        }
    },[isRunning]);
    
    useEffect(()=>{
        if(secondsLeft == 0){
            setCertNumberSendCheck(false);
            setEmail('');
            setCertNumber('');
        }
    },[secondsLeft]);
    
    useEffect(()=>{
        setCertNumberSendCheck(false);
        setCertNumberCertifiedCheck(false);
        setEmail('');
        resetTimer();
    },[logInUp]);
    
    const startTimer = () => {
        setSecondsLeft(INITIAL_SECONDS);
        setIsRunning(true);
    };

    const resetTimer = () => {
        clearInterval(timerRef.current);
        setIsRunning(false);
        setSecondsLeft(INITIAL_SECONDS);
    };
    // #endregion

    function validatePassword(password) {
        const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[:!@%$%^&*()+=._-])[A-Za-z\d:!@%$%^&*()+=._-]{8,16}$/;
        return regex.test(password);
    }

    const clickSignUp = async (e) => {
        e.preventDefault();    
        try{
            let result;
        
            //Email 체크가 되었는지
            if(!certNumberCertifiedCheck){
                alert(translate('email_verification_required'));
                return;
            }
            //이름 체크
            if(name === null || name === undefined || name.trim() === ''){
                alert(translate('enter_name'));
                return;
            }
            //키 체크
            if(height === null || height === undefined || height.trim() === ''){
                alert(translate('enter_height'));
                return;
            }
            //체중 체크
            if(weight === null || weight === undefined || weight.trim() === ''){
                alert(translate('enter_weight'));
                return;
            }
            
            //나이 체크
            if(age === null || age === undefined || age.trim() === ''){
                alert(translate('enter_age'));
                return;
            }

            //OAuth 회원가입이면 detail만 추가해주면 된다.
            if(secureLocalStorage.getItem('oauthData') !== null && secureLocalStorage.getItem('oauthData') !== undefined){
                
                let body = {
                    // user_id: secureLocalStorage.getItem("userId"),
                    // OAuth가 준 이메일 대신, 사용자가 직접 인증한 이메일을 저장한다.
                    // (카카오 전화번호 가입자는 이메일이 없고, 인증 단계에서 중복도 걸러지기 때문)
                    email: email,
                    name: name,
                    sex: gender,
                    age: Number(age),
                    height: Number(height),
                    weight: Number(weight),
                    social_type: Number(secureLocalStorage.getItem("oauthData").OAuth_type),
                    diabetes_type: diabetesType,
                    device_type_num: 1104 //웹
                }

                result = await agmsClientRequestPost("/api/user/detail_oauth", body, false, null, secureLocalStorage.getItem("pre_signup_token"));
                if(result.is_success){
                    alert(translate('signup_success'));
                    secureLocalStorage.setItem('accesstoken', result.access_token);
                    secureLocalStorage.setItem('refreshtoken', result.refresh_token);
                    secureLocalStorage.setItem("authUser", result.user_id);
                    // secureLocalStorage.setItem("email", secureLocalStorage.getItem("oauthData").email);
                    // secureLocalStorage.setItem("oauthType", secureLocalStorage.getItem("oauthData").OAuth_type);
                    // secureLocalStorage.setItem("oauthData", null);
                    history.push('/patient/list');
                    setLogInUp(false);
                    secureLocalStorage.setItem("oauthData", null);
                    //회원가입에 성공했다면 메인화면으로 가자.
                }
                else{
                    alert(translate('signup_failed'));
                }
            }
            else{
                //비밀번호 체크
                if(password === null || password === undefined || password.trim() === ''){
                    alert(translate('enter_password'));
                    return;
                }

                //비밀번호 동일한지 체크
                if(password !== passwordCheck){
                    alert(translate('password_mismatch'));
                    return;
                }
                //비밀번호 조건이 맞는지 체크
                if(!validatePassword(password)){
                    alert(translate('password_mismatch'));
                    return;
                }
                //동의 모두 체크가 되었는지
                if(termAllAgreeInfo.agree !== "true") {
                    alert(translate('terms_agreement_required'));
                    return;
                }
                let body = {
                    email : email,
                    pwd : password,
                    name : name,
                    sex : gender,
                    age : age,
                    height : height,
                    weight : weight,
                    social_type: 1803,
                    diabetes_type : diabetesType
                };
                result = await agmsClientRequestPost("/api/user/join", body);

                if(!result.is_joined){
                    alert(translate('signup_success_login'));
                    setLogInUp(false);
                }
                else{
                    alert(translate('signup_failed'));
                }
            }

        }
        catch (error) {
            if (error.response?.status === 416) {
                alert(translate('try_find_password'));
            } 
            else if (error.response?.status === 415) {
                alert(translate('already_registered_email'));
            }
            else if (error.response?.status === 412) {
                alert(translate('email_verification_expired'));
            } else if (error.response?.status === 410) {
                alert(translate('email_verification_expired_extended'));
            } else if (error.response?.status === 401) {
                if(error.response.data.result_code === 1002){
                alert(translate('please_check_your_login_details'));
                }else if(error.response.data.result_code === 1003){
                alert(translate('password_mismatch_exceeded'));
                }
                
            } else {
                alert(translate('unable_to_login'));
            }
        }

        
    };

    return(
        <form style={{
            
        }} className="w-100 h-100 d-flex flex-column align-items-center justify-content-center" onSubmit={clickSignUp}>
            <div style={{marginTop:'80px', marginBottom:'50px', fontWeight:'bold', fontSize:'38px'}}>
                {translate('signup')}
            </div>
            
            <div style={{
                width: "80%",
                lineHeight: "1",
                textAlign: "left",
                marginBottom: "20px",
                maxWidth:'400px'
            }}>
                <span style={{
                    fontWeight: "normal",
                    fontSize: "17px",
                    cursor: "default",
                    marginRight:'20px'
                }}>
                    {translate('already_have_account')}
                </span>

                <span onClick={onClickGoToLogin} style={{
                    fontWeight: "normal",
                    fontSize: "17px",
                    color: "#5E2589",
                    cursor: "pointer",
                }}>
                    <b>{translate('do_login')}</b>
                </span>
            </div>

            <div style={{ width: "80%", maxWidth:'400px'}}>
            
                <TextField 
                    disabled={certNumberSendCheck} 
                    fullWidth 
                    type='email'
                    label={translate('login_email_placeholder')}
                    value={email || ''}
                    onChange={(e) => setEmail(e.target.value)}/>

                <div style={{height:"5px"}}></div>
                
                <div style={{
                    display:'flex',
                    justifyContent:'end',
                }}>
                    {certNumberCertifiedCheck ? 
                        <>
                            <DoneIcon color="success"/>
                        </>
                        :
                        <>
                            {certNumberSendCheck ? 
                                <>
                                    <div><b>{formatTime(secondsLeft)}</b></div>
                                </>
                                :
                                <>
                                    <Button disabled={certNumberSendCheck} variant="contained" size="small" onClick={() => onSendEmailCode()}>
                                        {translate('send_verification_code')}
                                    </Button>
                                </>
                            }
                        </>
                    }
                </div>
                    
                <div style={{height:"25px"}}></div>

                <TextField 
                    disabled={!certNumberSendCheck || certNumberCertifiedCheck} 
                    fullWidth 
                    label={translate('enter_verification_code')}
                    value={certNumber || ''}
                    onChange={(e) => setCertNumber(e.target.value)}/>

                <div style={{height:"5px"}}></div>
                
                <div style={{
                    display:'flex',
                    justifyContent:'end',
                }}>
                    {certNumberCertifiedCheck ? 
                    <>
                        <DoneIcon color="success"/>
                    </>
                    :
                    <>
                        <Button disabled={!certNumberSendCheck} variant="contained" size="small" onClick={() => onCheckCertNumber()}>
                            {translate('confirm')}
                        </Button>
                    </>}
                </div>


                {certNumberCertifiedCheck ?
                <>
                    <div style={{height:"25px"}}></div>

                    <TextField 
                        fullWidth 
                        label={translate('name')} 
                        value={name || ''}
                        onChange={(e) => setName(e.target.value)}/>

                    <div style={{height:"25px"}}></div>
                    
                    <TextField 
                        fullWidth 
                        label={translate('height')}
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}/>

                    <div style={{height:"25px"}}></div>

                    <TextField 
                        fullWidth 
                        label={translate('weight')}
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}/>
                    
                    <div style={{height:"25px"}}></div>
                
                    <TextField 
                        fullWidth 
                        label={translate('age')} 
                        value={age}
                        onChange={(e) => setAge(e.target.value)}/>

                    <div style={{height:"25px"}}></div>
                
                    <FormControl fullWidth>
                        <InputLabel id="gender">{translate('gender')}</InputLabel>
                        <Select
                            labelId="gender"
                            id="gender"
                            value={gender}
                            label={translate('gender')}
                            onChange={(e) => setGender(e.target.value)}
                        >
                            <MenuItem value={1601}>{translate('male')}</MenuItem>
                            <MenuItem value={1602}>{translate('female')}</MenuItem>
                            <MenuItem value={1603}>{translate('none')}</MenuItem>
                        </Select>
                    </FormControl>

                    <div style={{height:"25px"}}></div>

                    <FormControl fullWidth>
                        <InputLabel id="diabetesType">{translate('diabetes_type')}</InputLabel>
                        <Select
                            labelId="diabetesType"
                            id="diabetesType"
                            value={diabetesType}
                            label={translate('diabetes_type')}
                            onChange={(e) => setDiabetesType(e.target.value)}
                        >
                            <MenuItem value={1701}>{translate('type_1_diabetes')}</MenuItem>
                            <MenuItem value={1702}>{translate('type_2_diabetes')}</MenuItem>
                            <MenuItem value={1703}>{translate('gestational_diabetes')}</MenuItem>
                            <MenuItem value={1704}>{translate('prediabetes')}</MenuItem>
                            <MenuItem value={1705}>{translate('lada')}</MenuItem>
                            <MenuItem value={1706}>{translate('normal')}</MenuItem>
                        </Select>
                    </FormControl>
                    
                    <div style={{height:"25px"}}></div>

                    <TextField 
                        fullWidth 
                        type="password"
                        label={translate('login_password_placeholder')} 
                        value={password}
                        onChange={onChangePasswordSignUp}/>
                    <div style={{marginLeft:'5px'}}>
                        {translate('password_requirements')}
                    </div>
                    <div style={{marginLeft:'5px'}}>
                        {translate('allowed_special_characters')}
                    </div>

                    <div style={{height:"15px"}}></div>
                
                    <TextField 
                        fullWidth 
                        type="password"
                        label={translate('password_confirmation')}
                        value={passwordCheck} 
                        onChange={(e) => setPasswordCheck(e.target.value)}/>
                        
                    <div style={{
                        width: "100%",
                        borderRadius: "6px",
                        padding: "13px 16px",
                    }}>
                        <div>
                            <span
                                style={{
                                fontWeight: "normal",
                                //fontSize: "17px",
                                color: "blue",
                                cursor: "pointer",
                                }}
                                onClick={() => setTermAgreement(!termAgreement)}
                            >
                                <Checkbox 
                                    checked={termAllAgreeInfo.agree}
                                />
                                <u>{translate('need_terms_agreement_required')}</u>
                            </span>
                        </div>
                    </div>  
                </> 
                : 
                <></>}

             
            </div>
            <div style={{height:"25px"}}></div>
            <div style={{ width: "80%", marginBottom: "20px", maxWidth:'400px'}}>
                <button
                    style={{
                    width: "100%",
                    backgroundColor: "#5E2589",
                    color: "#fff",
                    fontSize: "17px",
                    fontWeight: "600",
                    border: "none",
                    borderRadius: "4px",
                    padding: "16px 0px",
                    }}
                    onClick={clickSignUp}
                >
                    {translate('register')}
                </button>
            </div>
        </form>
    );
};

export default withRouter(SignUpComponent);